<template>
	<PreviewWrapper
		:loading="isLoading"
		:loaded="isLoaded"
		class="ao-preview-layout"
	>
		<PreviewAdvancedHeader
			v-bind="headerProps"
			class="mb-4"
		/>
		<PreviewAdvancedMap
			v-if="previewMapProps.mapInfo"
			v-bind="previewMapProps"
			class="mb-4"
		/>
		<slot name="default"/>
		<template
			v-for="section in sections"
			:key="`section-${section.key}`"
		>
			<slot
				:name="`section--${section.key}`"
			>
				<PreviewCollapse :title="section.title">
					<slot
						:name="`section--${section.key}--content`"
					>
						<PreviewAdvancedList
							v-if="section.type === PREVIEW_SECTION_TYPES.ADVANCED_LIST"
							:items="section.data ?? []"
						/>
					</slot>
				</PreviewCollapse>
			</slot>
		</template>
	</PreviewWrapper>
</template>

<script setup>
import {
	PreviewWrapper,
	PreviewAdvancedHeader,
	PreviewAdvancedMap,
	PreviewCollapse,
	PreviewAdvancedList,
	// PreviewSubtitle,
	// PreviewStatus,
	// PreviewList,
	// PreviewInventoryItems,
	// PreviewActions,
	// PreviewNoData,
} from '@/components/ui/preview'

import { PREVIEW_SECTION_TYPES } from '@/config/preview/previewConfig'

defineProps({

	isLoading: {
		type: Boolean,
		default: false,
	},

	isLoaded: {
		type: Boolean,
		default: false,
	},

	headerProps: {
		type: Object,
	},

	previewMapProps: {
		type: Object,
	},

	actions: {
		type: Array,
		default: () => ([]),
	},

	/* [{
			key: String, // unique
			type: String, // PREVIEW_SECTION_TYPES
			title: String,
			// data: [Object, Array, String],
		}, ...] */
	sections: {
		type: Array,
		default: () => ([]),
	},

})
</script>
